export default "__VITE_ASSET__DNwRm3MO__"